export default {"src":"/_next/static/media/webix.61c9b31f.svg","height":213,"width":256,"blurWidth":0,"blurHeight":0};